import React from 'react';

const LINKTIME_URL_RE = /^(?:https?:\/\/)?(?:link\.numfree\.com\/|app\.numfree\.com\/link\/)([a-z0-9_-]{3,30})\/([a-z0-9_-]{1,20})\/?$/i;
const LRU_CACHE_MAX = 80;
const linktimePreviewCache = new Map();

const _linktimeCacheSet = (k, v) => {
  if (linktimePreviewCache.size >= LRU_CACHE_MAX) {
    linktimePreviewCache.delete(linktimePreviewCache.keys().next().value);
  }
  linktimePreviewCache.set(k, v);
};

const LinkTimePreviewPill = ({ href, alias, code, fallbackText }) => {
  const [state, setState] = React.useState(() => {
    const key = alias + '/' + code;
    return linktimePreviewCache.get(key) || { loading: true };
  });
  React.useEffect(() => {
    const key = alias + '/' + code;
    const cached = linktimePreviewCache.get(key);
    if (cached && !cached.loading) return;
    let cancelled = false;
    fetch('/api/linktime/join/' + encodeURIComponent(alias) + '/' + encodeURIComponent(code), { credentials: 'include' })
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(data => { if (!cancelled) { _linktimeCacheSet(key, { loading: false, data }); setState({ loading: false, data }); } })
      .catch(err => { if (!cancelled) { const n = { loading: false, error: typeof err === 'number' ? 'HTTP ' + err : 'Failed to load' }; _linktimeCacheSet(key, n); setState(n); } });
    return () => { cancelled = true; };
  }, [alias, code]);
  const meetingName = (state.data && state.data.meeting_name) || fallbackText || code;
  const roomName = state.data && state.data.room_name;
  const expired = state.data && state.data.expires_at && new Date(state.data.expires_at) < new Date();
  const requiresPwd = state.data && state.data.requires_password;
  const hostOnline = state.data && state.data.host_online;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={'linktime-pill' + (expired ? ' expired' : '')}>
      <span className="linktime-pill-icon">🎥</span>
      <span className="linktime-pill-body">
        <span className="linktime-pill-title">{state.loading ? 'Loading…' : meetingName}{hostOnline && <span className="linktime-pill-live" title="Host is online">●</span>}</span>
        {(roomName || expired || requiresPwd || state.error) && <span className="linktime-pill-meta">{roomName && <span>{roomName}</span>}{requiresPwd && <span>· password</span>}{expired && <span>· expired</span>}{state.error && <span>· {state.error}</span>}</span>}
      </span>
    </a>
  );
};

export const markdownComponents = {
  a: function MdLink(props) {
    const href = String(props.href || '');
    const m = LINKTIME_URL_RE.exec(href);
    if (m) {
      const children = props.children;
      const text = Array.isArray(children) ? children.join('') : String(children || '');
      return <LinkTimePreviewPill href={href} alias={m[1]} code={m[2]} fallbackText={text} />;
    }
    return <a href={href} target="_blank" rel="noopener noreferrer">{props.children}</a>;
  }
};
